module.exports = {"profConditions-link":"Condiciones para profesionales","patConditions-link":"Condiciones para pacientes","telemedicineCompanies-link":"Salud y bienestar para empresas","contact-link":"Contacto","legalNotice-link":"Aviso legal y cookies","questions-link":"Preguntas frecuentes","lastUpdate":"Última actualización"}


//////////////////
// WEBPACK FOOTER
// ./src/lang/mx/public/footer.json
// module id = 591
// module chunks = 116